import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import api from '@/api/dmarketing';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async list(params: any) {
        return api.list(params);
    }

    @Action
    async add(params: any) {
        return api.add(params)
    }

    @Action
    async rushHour(params: any) {
        return api.rushHour(params)
    }

    @Action
    async getRushHour(params: any) {
        return api.getRushHour(params)
    }

    @Action
    async addRushHour(params: any) {
        return api.addRushHour(params)
    }

    @Action
    async editRushHour(params: any) {
        return api.editRushHour(params)
    }

    @Action
    async deleteRushHour(params: any) {
        return api.deleteRushHour(params)
    }
}
